<template>
  <div class="nodata-wrap" :style="{ minHeight: props.minHeight, height: props.height }">
    <h4>
      {{
        !userInfo.user_no
          ? $t("trading.error.105")
          : userState
          ? $t("trading.common.noData")
          : $t("trading.common.sts")
      }}
    </h4>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useStore } from "vuex";
const store = useStore();
const props = defineProps({
  minHeight: String,
  height: String,
});
const userInfo = computed(() => store.state.userInfo.userInfo);
const userState = computed(() => store.state.account.userState);
</script>

<style lang="scss" scoped>
.nodata-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  gap: 3rem;
  color: var(--medium-color);
  h4 {
    color: var(--txt-default-color);
  }
}
@media screen and (max-width: 768px) {
  .nodata-wrap {
    h4 {
      font-size: 2.6rem;
    }
    img {
      width: 50px;
    }
  }
}
</style>
